import "./progressBar.css";
import { useState, useEffect } from "react";
export const ProgressBar = ({ percent, status }) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    setValue(percent * 100);
  });

  return (
    <div className={"progressComp"}>
      <label className="percent-number">{status}</label>
      <div className="progress-div" style={{ width: "100%" }}>
        <div style={{ width: `${value}%` }} className="progress" />
      </div>
    </div>
  );
};
